export default __webpack_public_path__ + "a435a0a5214a10f5aefc05bc39aa5e19.png";